<template>
  <div>
    <h2
      class="kbx-description"
      v-if="stepPreview.description_visibility"
      klickbox-edit-item="welcome-description"
      :klickbox-edit-label="$t('edit.canvas.welcome_description')"
      klickbox-edit-label="Descrição de Boas Vindas"
      :style="stepStyle('welcome-description')">
      <text-editor
        :content="stepPreview.description_text"
        :change="onChange"
        :toolbar="true"
        :placeholder="$t('edit.canvas.welcome_description')"></text-editor>
    </h2>
  </div>
</template>

<script>
import TextEditor from 'src/components/general/TextEditor/Main';
import { mapGetters } from 'vuex';

export default {
  components: {
    TextEditor,
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
    stepPreview: 'stepPreview',
  }),
  methods: {
    onChange(text) {
      this.$store.dispatch('stepUpdateDescriptionText', {
        event: { target: { value: text } },
        id: this.stepPreview.id,
      });
    },
  },
};
</script>



/** WEBPACK FOOTER **
 ** Description.vue?78fdf1f9
 **/